import GameSignals from '@/signals/GameSignals'
import { BaseChildState } from '@stateMachine/BaseChildState'
import gsap from 'gsap'

export class BetCooldownState extends BaseChildState {
    public canTrigger(): boolean {
        return this._model.spinState.needsBetCooldown
    }

    public begin(): void {
        gsap.to(this, {
            duration: 0.2,
            onComplete: () => {
                this.startBetCooldown()
            },
        })
    }

    protected startBetCooldown(): void {
        const { roundState, spinState, initData } = this._model

        if (roundState.isFreeSpins) {
            // no need to pause gameplay in free spins
            this.stopBetCooldown()
            return
        }

        const spinTime = Date.now() - spinState.spinStartTime
        const waitTime = Math.max(0, 0 - spinTime)

        setTimeout(this.stopBetCooldown, waitTime)
    }

    protected stopBetCooldown = () => {
        this._model.spinState.needsBetCooldown = false
        GameSignals.betCooldownEnded.emit()
        this.end()
    }
}
